import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';

import { EditorState } from 'editor/src/store/editor/types';

const setIsLoadingReducer = (state: EditorState, action: PayloadAction<boolean>) => {
  state.isLoading = action.payload;
};

export default setIsLoadingReducer;
